import React, { Component } from 'react'
import Axios from 'axios'
import getDomainURL from 'utils/api'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      showSuccessMessage: false,
      successMessage: ''
    }

    onChangeHOC = ( val, context ) => this.setState({ [context]: val })

    onClickSubmit = ({ token, password, password_confirm }) => {
      if ( !password || !password_confirm ) {
        return this.setState({ 
          showErrorMessage: true, 
          errorMessage: 'Please fill in all fields.' 
        })
      }

      if ( password !== password_confirm ) {
        return this.setState({ 
          showErrorMessage: true, 
          errorMessage: 'Passwords do not match.' 
        })
      }

      this.setState({ loading: true, showErrorMessage: false, showSuccessMessage: false }, () => {
        Axios.post(
          `${ getDomainURL() }/password-reset/confirm`, {
            token,
            password,
            password_confirm
          }).then( response => {
            this.setState({ 
              loading: false,
              showSuccessMessage: true,
              successMessage: 'Password has been reset successfully. Redirecting to login...'
            })
            setTimeout(() => {
                this.props.history.push('/login')
            }, 3000)
          }).catch( error => {
            this.setState({ 
              showErrorMessage: true, loading: false, 
              errorMessage: error.response?.data?.message || 'Failed to reset password. Please try again or request a new link.'
            })
        });
      })
    }

    render = () => {
      return (
        <WrappedComponent 
          { ... this.props }
          showErrorMessage={ this.state.showErrorMessage }
          showSuccessMessage={ this.state.showSuccessMessage }
          onLoadReset={ this.state.loading }
          errorMessage={ this.state.errorMessage }
          successMessage={ this.state.successMessage }
          onChangeHOC={ this.onChangeHOC }
          onClickSubmit={ this.onClickSubmit }/>
      )
    }
  }
  return WithHOC;
}
export default HOC
